/*
 * File: FormFields.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Iterates over the form fields and returns the input type, label and error message
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import FormFieldControl from "./FormFieldControl";
import SnackBar from "components/ui/UISnackbar";

const FormFields = ({ fields, data, parentOnChange }) => {
  let hasError = fields.filter(f => f.errorMessage !== null).length > 0;
  let formFieldItems = fields.map((field, idx) => {
    if (field.hidden) return "";
    return (
      <FormFieldControl
        key={idx}
        field={field}
        data={data}
        parentOnChange={parentOnChange}
      />
    );
  });

  return (
    <React.Fragment>
      <SnackBar
        variant="error"
        message="Errors were found..."
        open={hasError}
      />
      {formFieldItems}
    </React.Fragment>
  );
};

FormFields.propTypes = {
  fields: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  parentOnChange: PropTypes.func.isRequired
};

export default observer(FormFields);
